import { Star, Quote } from 'lucide-react';

export function Avatar({ initials, bg }) {
  return (
    <div className={`w-11 h-11 rounded-full ${bg} flex items-center justify-center text-sm font-bold text-navy flex-shrink-0`}>
      {initials}
    </div>
  );
}

export function Stars({ rating, size = 14 }) {
  return (
    <div className="flex items-center gap-0.5">
      {[...Array(5)].map((_, i) => (
        <Star key={i} size={size} className={i < rating ? 'fill-orange text-orange' : 'fill-muted text-muted'} />
      ))}
    </div>
  );
}

export default function ReviewCard({ review }) {
  return (
    <div className="h-full bg-white rounded-2xl border border-navy/10 p-7 flex flex-col">
      <div className="flex items-center justify-between mb-4">
        <span className="text-xs font-semibold text-navy/60 bg-navy/5 px-3 py-1 rounded-full">{review.source}</span>
        <Quote className="w-8 h-8 text-orange/15" />
      </div>
      <Stars rating={review.rating} />
      <p className="text-sm text-navy/80 leading-relaxed mt-4 flex-1">"{review.text}"</p>
      <div className="flex items-center gap-3 mt-6 pt-5 border-t border-navy/5">
        <Avatar initials={review.initials} bg={review.avatarBg} />
        <div className="min-w-0">
          <p className="text-sm font-semibold text-navy truncate">{review.name}</p>
          <p className="text-xs text-muted-foreground truncate">{review.role}</p>
        </div>
        <span className="ml-auto text-xs text-muted-foreground flex-shrink-0">{review.date}</span>
      </div>
    </div>
  );
}